import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notice"
export default class extends Controller {
    static targets = ["close", "notice"]
  connect() {
        this.hide()
  }
    close() {
        this.noticeTarget.classList.add('hidden')
        this.noticeTarget.remove()
    };
    hide() {
        setTimeout(() => {
        this.close()
        }, 5000);
    }
}
